import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { HomeIcon, FileTextIcon, AlertCircleIcon } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';
interface StudentSidebarProps {
  droppedOffCount?: number;
}
const StudentSidebar: React.FC<StudentSidebarProps> = ({
  droppedOffCount = 0
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [hoveredItem, setHoveredItem] = useState<string | null>(null);
  const navItems = [{
    id: 'home',
    label: 'Home',
    icon: HomeIcon,
    path: '/student'
  }, {
    id: 'reports',
    label: 'Reports',
    icon: FileTextIcon,
    path: '/student/reports'
  }];
  const Tooltip = ({
    children,
    label,
    show
  }: {
    children: React.ReactNode;
    label: string;
    show: boolean;
  }) => <div className="relative" data-id="element-2379">
      {children}
      <AnimatePresence data-id="element-2380">
        {show && <motion.div initial={{
        opacity: 0,
        x: -5
      }} animate={{
        opacity: 1,
        x: 0
      }} exit={{
        opacity: 0,
        x: -5
      }} transition={{
        duration: 0.15
      }} className="absolute left-full ml-3 top-1/2 -translate-y-1/2 px-3 py-1.5 bg-black/90 text-white text-xs font-medium rounded-lg whitespace-nowrap pointer-events-none shadow-lg" style={{
        zIndex: 9999
      }} data-id="element-2381">
            {label}
          </motion.div>}
      </AnimatePresence>
    </div>;
  return <aside className="w-16 h-screen sticky top-0 flex flex-col bg-white shadow-sm" data-id="element-2382">
      {/* Logo/Brand Space */}
      <div className="p-3 pt-6" data-id="element-2383">
        <div className="w-10 h-10 rounded-full bg-[#00B75F] flex items-center justify-center" data-id="element-2384">
          <span className="text-white font-bold text-sm" data-id="element-2385">A</span>
        </div>
      </div>

      {/* Navigation Items */}
      <nav className="flex-1 px-3 flex flex-col gap-4 mt-4" data-id="element-2386">
        {navItems.map(item => {
        const Icon = item.icon;
        const isActive = location.pathname === item.path;
        return <Tooltip key={item.id} label={item.label} show={hoveredItem === item.id} data-id="element-2387">
              <motion.button onClick={() => navigate(item.path)} onMouseEnter={() => setHoveredItem(item.id)} onMouseLeave={() => setHoveredItem(null)} whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className={`w-10 h-10 rounded-2xl flex items-center justify-center transition-all duration-200 ${isActive ? 'bg-[#00B75F] text-white shadow-md' : 'bg-gray-50 text-gray-600 hover:bg-gray-100'}`} data-id="element-2388">
                <Icon size={20} data-id="element-2389" />
              </motion.button>
            </Tooltip>;
      })}
      </nav>

      {/* Dropped Off Section - Bottom of sidebar */}
      {droppedOffCount > 0 && <div className="px-3 pb-6" data-id="element-2390">
          <Tooltip label={`${droppedOffCount} Dropped Off`} show={hoveredItem === 'dropped-off'} data-id="element-2391">
            <motion.button onClick={() => {
          navigate('/student/reports');
          // Set filter to dropped-off via URL param or state
          window.dispatchEvent(new CustomEvent('setReportsFilter', {
            detail: 'dropped-off'
          }));
        }} onMouseEnter={() => setHoveredItem('dropped-off')} onMouseLeave={() => setHoveredItem(null)} whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="w-10 h-10 rounded-2xl flex items-center justify-center transition-all duration-200 bg-red-50 text-red-600 hover:bg-red-100 relative" data-id="element-2392">
              <AlertCircleIcon size={20} data-id="element-2393" />
              {droppedOffCount > 0 && <span className="absolute -top-1 -right-1 w-5 h-5 bg-red-500 text-white text-xs font-bold rounded-full flex items-center justify-center" data-id="element-2394">
                  {droppedOffCount}
                </span>}
            </motion.button>
          </Tooltip>
        </div>}
    </aside>;
};
export default StudentSidebar;